
/*========================== Image Arrows Hover Logic ==========================*/
parseInt("") <= 1 && $('#arrow-container').addClass('singular-image')
/*========================== End Image Arrows Hover Logic ======================*/


/*========================== Related Products Copy Sizing Logic ==========================*/
$(document).ready(() => {
    let productCardHeight = window.matchMedia("(min-width: 769px)").matches ? $('.collection__product_card_image img').height() : 250
    let relatedProductsCopy = $('.product__related_products_copy_inner')
    relatedProductsCopy && $(relatedProductsCopy).css('min-height', productCardHeight)
})

$(window).on('load resize scroll', () => {
    let productCardHeight = window.matchMedia("(min-width: 769px)").matches ? $('.collection__product_card_image img').height() : 250
    let relatedProductsCopy = $('.product__related_products_copy_inner')
    relatedProductsCopy && $(relatedProductsCopy).css('min-height', productCardHeight)
})
/*========================== (end)Related Products Copy Sizing Logic ==========================*/


/*========================== Image Slider Logic ==========================*/
$("body").on("keydown", function (e) {
    var code = e.keyCode;
    if (code === 37) selectThumbOrVariant(null, 'left')
    if (code === 39) selectThumbOrVariant(null, 'right')
});

const selectThumbOrVariant = (event, arrowDirection) => {
    if (arrowDirection) {
        let $currentSelected = $('.selected-thumb')
        if (arrowDirection === 'left') {
            let $prevImage = $currentSelected.closest('li').prev().attr('id')
                ? $currentSelected.closest('li').prev().find('img')
                : $('.product-photo-thumbs .product-photo-thumb').last().find('img')
            let image_id = $prevImage.attr('id')
            let data_index = $prevImage.data('index')
            let image_src = $prevImage.data('img-src')
            switchImageLocal({ src: image_src, 'data-image-id': image_id, 'data-index': data_index })
        }
        else if (arrowDirection === 'right') {
            let $nextImage = $currentSelected.closest('li').next().attr('id')
                ? $currentSelected.closest('li').next().find('img')
                : $('.product-photo-thumbs .product-photo-thumb').first().find('img')
            let image_id = $nextImage.attr('id')
            let data_index = $nextImage.data('index')
            let image_src = $nextImage.data('img-src')
            switchImageLocal({ src: image_src, 'data-image-id': image_id, 'data-index': data_index })
        }
    }
    else {

        let image_id = $(event.target).attr('id')
        let data_index = $(event.target).data('index')
        let image_src = $(event.target).data('img-src')
        $('.selected-thumb').removeClass('selected-thumb')
        $(event.target).closest('span').addClass('selected-thumb')

        let imgObject = { src: image_src, 'data-image-id': image_id, 'data-index': data_index }
        switchImageLocal(imgObject)
    }
}
const switchImageLocal = imgObject => $('#productPhotoImg').attr({ 'src': imgObject.src, 'data-image-id': imgObject['data-image-id'], 'data-index': imgObject['data-index'] })


/*======================== END Image Slider Logic ========================*/

/*========================================================================*/
/*================= Product Description/Selection Logic ==================*/
/*========================================================================*/

/*========================================================================*/
/*================ End Product Description/Selection Logic ===============*/
/*========================================================================*/


/*======================= PDP Video Module Logic =========================*/
const videoHandler = (event) => {

    if ($('.video-container').attr('id') === 'closed') {
        $('.video-container').attr('id', 'opened')
        $('.video-container').addClass('video-open')
        $('.video-container video').attr('autoplay', 'true').trigger('play')
        $('.guarantee-box, .product-photo-thumbs').addClass('hidden')
    }
    else {
        $('.video-container').attr('id', 'closed')
        $('.video-container').removeClass('video-open')
        $('.video-container video').attr('autoplay', 'false').trigger('pause')
        $('.guarantee-box, .product-photo-thumbs').removeClass('hidden')
    }
}




/*===================== END PDP Video Module Logic =======================*/

/*===================== Backorder Messaging Logic =======================*/
const backorderMessagingUpdate = date => {
  if (date != "") {
    $('#backorder-date')[0].innerText = `Preorder - Ships by ${date}`; 
    $('#addText')[0].innerText = `Preorder - Ships by ${date}`; 

  } else {
    $('#backorder-date')[0].innerText = ''
  }
}

const underCTAupdate = date => {
    $('#underCTA').replaceWith(`<p class="ma cbld fw4" id="underCTA">Need a gift by Christmas? Your Candle will ship now & your preordered Bathrobe will ship by ${date}</p>`);
}

const backorderComponentUpdate = (list, message) => {
  if (list != "") {
    let formattedList = list.split(',').join('\n')
    $('.bundle-backorder-list')[0].innerText = `${formattedList}`
    $('.bundle-backorder-main-message')[0].innerText = `${message}`
  } else {
    $('.bundle-backorder-list')[0].innerText = ''
    $('.bundle-backorder-main-message')[0].innerText = ''
  }
}

/*===================== END Backorder Messaging Logic =======================*/

/*===================== Product Quantity Logic =======================*/
const adjustQuantity = (event) => {
    if (event.currentTarget.id === 'minus-quantity' && $('#quantity').val() > 1) {
        $('#quantity').val(parseInt($('#quantity').val()) - 1)
    }
    if (event.currentTarget.id === 'plus-quantity') {
        $('#quantity').val(parseInt($('#quantity').val()) + 1)
    }
    $('#quantity-amount').replaceWith(`<div id='quantity-amount' class="f jcc"><p>${$('#quantity').val()}</p></div>`)
}
/*===================== END Product Quantity Logic =======================*/

/*===================== (end) Product Swatch/Text Change Logic =======================*/


/*========================== PDP Value Prop Text Container Size =========================*/



/*========================== (end) PDP Value Prop Text Container Size =========================*/
